export default {
  title: 'AUTO DISPATCH FOR RUNS SETTINGS',
  items: {
    RunNewdispatchEnabled: {
      label: 'RUN Auto Dispatch Enabled',
      type: 'boolean',
    },
    RunNewdispatchRadius: {
      label: 'RUN Auto Dispatch Radius',
      type: 'integer',
      unit: ''
    },
    RunNewdispatchAnnounce: {
      label: 'RUN Auto Dispatch Announce',
      type: 'boolean',
    },
    RunAutodispatch3Enabled: {
      label: 'RUN Auto Dispatch Enabled v3',
      type: 'boolean',
    },
    RunAutodispatch3UpcomingHours: {
      label: 'RUN Auto Dispatch Upcoming Hours v3',
      type: 'integer',
      unit: 'Hours'
    },
    RunAutodispatch3MaxOfferMiles : {
      label: 'RUN Auto Dispatch Max Miles v3',
      type: 'integer',
      unit: 'Miles'
    },
    RunNewdispatchTimer: {
      label: 'Run New Dispatch Timer',
      type: 'integer',
      unit: 'seconds'
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/settings-config/auto-dispatch-runs.js